import { InputNumber, InputNumberProps } from 'antd';

const InputNumberForm = (props: InputNumberProps) => {
  return (
    <InputNumber
      size="large"
      className={`${props.className} w-full`}
      {...props}
    />
  );
};

export default InputNumberForm;
